/* src/main/webapp/app/components/layout/footer/footer.component.scss */
.footer-year-select {
  font-size: 12px;
  padding-top: 0.1rem;
  padding-bottom: 0.1rem;
  line-height: 1.2;
}
/*# sourceMappingURL=footer.component-F5BVFTAD.css.map */
